import { useFlags } from 'launchdarkly-react-client-sdk';

import { useCustomAuth } from 'auth/AuthContext';
import useFeatureSettings from 'hooks/queries/useFeatureSettings';

/**
 * Hook that determines if the user has content-only mode enabled.
 * Returns the permission status and loading state.
 */
export const useContentOnlyPermission = () => {
    const { isAuthenticated, isLoading: isAuthLoading } = useCustomAuth();
    const {
        data: featureSettings,
        isSuccess: isFeatureSettingsSuccess,
        isInitialLoading: isFeatureSettingsLoading,
    } = useFeatureSettings({
        enabled: isAuthenticated,
    });
    const { contentOnly: hasContentOnlyFlag } = useFlags();
    const hasContentOnly = featureSettings?.content_only_mode_enabled && hasContentOnlyFlag;

    // Loading if auth is loading OR feature settings are loading OR LaunchDarkly flags aren't ready yet
    const isLoading = isAuthLoading || isFeatureSettingsLoading || hasContentOnlyFlag === undefined;

    return {
        hasContentOnly: isFeatureSettingsSuccess && hasContentOnly,
        isLoading,
    };
};
